import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { map } from 'rxjs';
import { StorageKey } from '../model/storage.enums';
import { AuthStateProvider } from '../services/auth/auth-state.provider';
import { AuthStateService } from '../services/auth/auth-state.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const authStateProvider = inject(AuthStateProvider);
  const authState = inject(AuthStateService);
  const router = inject(Router);
  const cookieService = inject(CookieService);
  const user = authState.userDetails();
  if (!cookieService.get(StorageKey.UserIO)) {
    if (state.url === '/auth/register') {
      return router.createUrlTree(['/auth/login']);
    }
    return true;
  }
  if (state.url === '/auth/register' && !user?.company) {
    return true;
  } else if (user) {
    return user.company ? router.createUrlTree(['/dashboard']) : router.createUrlTree(['/auth/register']);
  } else {
    return authStateProvider
      .fetchDetails()
      .pipe(
        map(() =>
          authState.userDetails()?.company
            ? router.createUrlTree(['/dashboard'])
            : router.createUrlTree(['/auth/register']),
        ),
      );
  }
};
